// extracted by mini-css-extract-plugin
export var closeButton = "_ly-1";
export var closeX = "_ly-3";
export var container = "_ly-0";
export var image = "_ly-2";